import { render } from "./TestPage.vue?vue&type=template&id=ff180b1e&scoped=true"
import script from "./TestPage.vue?vue&type=script&lang=js"
export * from "./TestPage.vue?vue&type=script&lang=js"

import "./TestPage.vue?vue&type=style&index=0&id=ff180b1e&scoped=true&lang=css"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff180b1e"]])

export default __exports__